<template>
  <form-section-checkbox
    v-if="isAvailable"
    :title="$t('CampaignForm_Schedule_Campaign_RateLimit_Title')"
    :description="$t('CampaignForm_Schedule_Campaign_RateLimit_Description')"
    class="RateLimit__Checkbox"
    v-model="model.rate_limit"
    :disabled="readonly"
    data-qa="campaign-rate-limit-checkbox"
  >
    <form-item prop="rate_limit_data" class="m-top-10">
      <el-row :gutter="20">
        <el-col
          v-for="messageType in selectedMessageTypes"
          :key="messageType"
          :span="8"
          style="margin-bottom: 20px"
        >
          <form-item
            :label="$t(MessageTypeLabel[messageType])"
            :description="
              $t('CampaignForm_Schedule_Campaign_RateLimit_MessagesPerMinute')
            "
          >
            <el-input-number
              :value="getLimit(messageType)"
              style="width: 100%"
              :min="1"
              :step="1"
              step-strictly
              :disabled="readonly"
              placeholder="∞"
              :data-qa="`campaign-rate-limit-input-${messageType}`"
              @input="setLimit(messageType, $event)"
            />
          </form-item>
        </el-col>
      </el-row>
    </form-item>
  </form-section-checkbox>
</template>

<script>
import FormSectionCheckbox from '@/common/components/form/FormSectionCheckbox'
import FormItem from '@/common/components/form/FormItem'
import { MessageTypeLabel } from '@/common/enum/MessageTypeEnum'
import {
  rateLimitMessageTypes,
  channelByMessageType
} from '@/modules/campaign-manage/enum/RateLimitEnum'

export default {
  name: 'CampaignRateLimitComponent',
  components: {
    FormSectionCheckbox,
    FormItem
  },
  props: {
    model: Object,
    isRateLimitAvailable: Boolean,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      MessageTypeLabel
    }
  },
  mounted() {
    this.initRateLimit()
  },
  methods: {
    initRateLimit() {
      if (!this.isAvailable) {
        this.$set(this.model, 'rate_limit', 0)
        this.$set(this.model, 'rate_limit_data', null)
      } else if (!this.model.rate_limit_data) {
        this.$set(this.model, 'rate_limit_data', {})
      }
    },
    getLimit(messageType) {
      // el-input-number treats null as 0, undefined keeps the input empty
      return (
        (this.model.rate_limit_data &&
          this.model.rate_limit_data[messageType]) ||
        undefined
      )
    },
    setLimit(messageType, value) {
      if (value) {
        this.$set(this.model.rate_limit_data, messageType, value)
      } else {
        this.$delete(this.model.rate_limit_data, messageType)
      }
    }
  },
  computed: {
    isAvailable() {
      // e.g. inbox only campaigns have nothing to limit
      return this.isRateLimitAvailable && this.selectedMessageTypes.length > 0
    },
    selectedMessageTypes() {
      return rateLimitMessageTypes.filter(
        messageType => !!this.model[channelByMessageType[messageType]]
      )
    }
  },
  watch: {
    isAvailable() {
      this.initRateLimit()
    },
    selectedMessageTypes(messageTypes) {
      // drop limits of channels which are no longer selected
      if (!this.model.rate_limit_data) {
        return
      }
      Object.keys(this.model.rate_limit_data)
        .filter(messageType => !messageTypes.includes(Number(messageType)))
        .forEach(messageType =>
          this.$delete(this.model.rate_limit_data, messageType)
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/schedule/CampaignRateLimitComponent.vue